import store from "../store";
import { getTicket, setIdentity, setTicket, setToken, setTokenExpiryDate,setOrganizationName } from "../utils/auth";
import { getPublicKey } from "@/api/user";
import {saveTasks} from '@/api/events';
import {saveInformations} from '@/api/message';
import {Message} from "portal-component";
import { getQueryString } from '@/utils/utils'
import {checkIfTokenValid,login} from "./utils";
import * as Cookies from "js-cookie"
import configR from '@/configs.js';

// 用来解码登录返回的 ticket
let decodeTicket = async() => {

  store.commit("SET_REFRESH_STATUS",true);
  // 调取事务搜索接口
  saveTasks({
    limit: 100,
    page:1
  })
  // 调取消息搜索接口
  saveInformations({
    pageSize: 100,
    pageIndex:0
  })
  // cas验证
  if (window.location.href.indexOf("ticket=") !== -1) {
    let url = decodeURIComponent(location.href);
    let ticketIndex = url.indexOf("ticket=");
    let routerIndex = url.indexOf("#/") !== -1 ? url.indexOf("#/") : url.length;
    if (ticketIndex !== -1) {
      let ticket = url.substring(ticketIndex + 7, routerIndex);
      console.log('ticket', ticket)
      try {
        let userInfo = JSON.parse(
          decodeURIComponent(escape(window.atob(ticket.split(".")[1])))
        );
        let identity =
          userInfo.identityTypeCode.trim().charAt(0).toUpperCase() +
          userInfo.identityTypeCode.trim().slice(1);
        const organizationName = userInfo.organizationName
        checkIdentity(ticket,userInfo.idToken,identity,organizationName)
        return true;
      }
      catch(err){
        Message({
          message: '登陆错误！',
          type: "error",
          duration: 2 * 1000
        });
        return false
      }

    }
  }
  // uniAuth 验证
  if(configR.envConfigs.LOGIN_WAY === 'uniAuth' && location.href.indexOf("id_token") !== -1){
    let jsrsasign = require('jsrsasign');
    let ticket = getQueryString('id_token');
    let secret;
    try{
      // 获取验签的key
      secret = await getPublicKey()
    }
    catch(err) {
      Message({
        message: '登陆验证失败！',
        type: "error",
        duration: 1000
      });

      return false
    }
    let pubKey = jsrsasign.KEYUTIL.getKey(secret)
    let isValid = jsrsasign.KJUR.jws.JWS.verifyJWT(ticket, pubKey, {
      alg: ['RS512'],
      iss: ["uniauth"],
      aud: ["uniauth"]
    })

    if(!isValid) {
      // 验证不通过
      Message({
        message: '登陆验证失败！',
        type: "error",
        duration: 1000
      });
      if ("spa" === configR.envConfigs.ENTRY_MODE) {
        window.location.href = configR.envConfigs.APP_SPA_URL+`#/Tourist`;
      }else{
        window.location.href = configR.envConfigs.VUE_APP_URL+`#/Tourist`;
      }
      return false
    }
    let userInfo = jsrsasign.KJUR.jws.JWS.readSafeJSONString(jsrsasign.b64utoutf8(ticket.split(".")[1]));
    // if(store.state.user.uniAuthNonce !== userInfo.nonce) {
    //   // 验证不通过
    //   Message({
    //     message: '登陆验证失败！',
    //     type: "error",
    //     duration: 1000
    //   });
    //   return false;
    // }
    let identity =
      userInfo.itc.trim().charAt(0).toUpperCase() +
      userInfo.itc.trim().slice(1);
    const organizationName = userInfo.organizationName
    checkIdentity(ticket,ticket,identity,organizationName)

  }
}
// 身份码映射，处理跳转
let checkIdentity = async(ticket,token,identity,organizationName) => {
  console.log('token',token);
  // organizationName
  let identityMap = {
    [configR.envConfigs.MAPED_STUDENT_IDENTITY]:'Student',
    [configR.envConfigs.MAPED_TEACHER_IDENTITY]:'Teacher',
    [configR.envConfigs.MAPED_ADMIN_IDENTITY]:'Admin',
    [configR.envConfigs.MAPED_VISITOR_IDENTITY]:'Visitor'
  }

  /*映射为本地角色*/
  for (const key in identityMap) {
    if (!key) continue;
    let exist = key.split(',').some((ele) => {
      if (ele && ele.toLowerCase() === identity.toLowerCase()) return true;
    });
    if (exist) {
      identity = identityMap[key];
      break;
    }
  }
  setTicket(ticket);
  let jsrsasign = require('jsrsasign');
  // 解码token,得到token有效期
  let decodeToken = jsrsasign.KJUR.jws.JWS.readSafeJSONString(jsrsasign.b64utoutf8(token.split(".")[1]));
  setTokenExpiryDate(decodeToken.exp);
  setToken(token);
  setIdentity(identity);
  localStorage.setItem('token',token);
  store.commit("SET_ORGANIZATION_NAME",organizationName);
  Cookies.set("isLogin",true);

    window.location.href = configR.envConfigs.VUE_APP_URL;

}
window.onfocus = ()=>{
  if(store.state.user.userIdentity !== 'Tourist') {
    // 验证token是否有效
    if(!checkIfTokenValid(store.state.user.tokenExpiryDate)) {
      store.dispatch("signOut").then(() => {
        // window.location.href = `${process.env.VUE_APP_CAS_URL}login?service=${encodeURIComponent(process.env.VUE_APP_URL)}`
        login()
      });
    }
  }
  let token = window.localStorage.getItem('vuex') && JSON.parse(window.localStorage.getItem('vuex')).user.token || '';
  let userIdentity = window.localStorage.getItem('vuex') && JSON.parse(window.localStorage.getItem('vuex')).user.userIdentity || '';
  let userNav = store.state.user.userNav.length;
  // 验证无token，重新登陆
  // 无游客页面，直接登陆
  if(!token && configR.envConfigs.VUE_APP_DIRECT_LOGIN === 'true') {
   console.log('直接登陆');
    store.dispatch("signOut").then(() => {
      // window.location.href = `${process.env.VUE_APP_CAS_URL}login?service=${encodeURIComponent(process.env.VUE_APP_URL)}`
      login()
    });
    return;
  }
  // 有游客页面
  if(!token && userIdentity && userIdentity === 'Tourist' && userNav > 3) {
    window.location.reload();
  }
}

export default decodeTicket;





